import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  apnReady: false,
})

const appNexus = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.UPDATE_APN_TAG_READY:
      return state.set('apnReady', payload)
    default:
      return state
  }
}

export default appNexus
